import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentRound',
  pure: true,
  standalone: false
})
export class PercentRoundPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }

    return `${Math.round(value)}%`;
  }
}
